<template>
  <div>
    <hr />

    <DataTable
      :data="referenciadets"
      :columns="[
        { label: 'Diagnóstico', field: 'diagnosticoCodigo',
          format: (v, row) => `${v} - ${row.diagnosticoNombre}` },
        { label: 'Tipo',        field: 'tipo' },
        { label: 'Fecha Reg.',  field: 'referenciaFechaReg',
          format: (v) => getFormattedDate(v, 'DD/MM/YYYY') },
      ]"
      idField="idReferenciaDet"
      mensajeVacio="No hay diagnósticos registrados."
      :acciones="true"
      :mostrarInfo="false"
      :mostrarEditar="estadoPermitido"
      :mostrarVer="false"
      :mostrarEliminar="estadoPermitido"
      :mostrarBotonNuevo="estadoPermitido"
      @refresh="getData"
      @create="abrirModalCrear"
      @edit="({ idReferenciaDet }) => abrirModalEditar(idReferenciaDet)"
      @delete="({ idReferenciaDet }) => deleteReferenciaDet(idReferenciaDet)"
    >
    </DataTable>

    <!-- Modal -->
    <div
      class="modal fade"
      id="ventanaModal"
      tabindex="-1"
      aria-labelledby="ventanaModalLabel"
      aria-hidden="true"
      v-if="modalWindow"
    >
      <div class="modal-dialog modal-xl">
        <div class="modal-content">
          <div class="modal-header bg-primary">
            <span class="material-icons" style="font-size:24px; color:white">assignment</span>
            <h5 class="modal-title text-white ms-2" id="ventanaModalLabel">{{ titulo }}</h5>
            <button type="button" class="btn-close btn-close-white" data-bs-dismiss="modal"></button>
          </div>
          <form @submit.prevent>
            <div class="modal-body">
              <div class="row g-3">

                <!-- Búsqueda de Diagnóstico -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Diagnóstico</label>
                </div>
                <div class="col-md-10">
                  <div class="input-group">
                    <input
                      type="text"
                      class="form-control"
                      v-model="searchTextDiag"
                      @input="filterDiagnosticos"
                      @keyup.enter="toggleDropdown"
                      placeholder="Buscar diagnóstico..."
                    />
                    <button
                      class="btn btn-outline-secondary dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                      aria-expanded="false"
                      ref="dropdownButton"
                    >
                      <span class="material-icons" style="font-size:16px">search</span>
                    </button>
                    <ul
                      class="dropdown-menu dropdown-menu-end shadow"
                      style="max-height:250px; overflow-y:auto; width:100%"
                      ref="dropdownMenu"
                    >
                      <li
                        v-for="diagnostico in filteredDiagnosticos"
                        :key="diagnostico.idDiagnostico"
                      >
                        <a
                          class="dropdown-item text-truncate"
                          href="#"
                          @click.prevent="selectDiagnostico(diagnostico)"
                          :title="diagnostico.nombre"
                        >
                          {{ diagnostico.codigo }} — {{ diagnostico.nombre }}
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>

                <!-- Tipo -->
                <div class="col-md-2">
                  <label class="form-label fw-bold">Tipo</label>
                </div>
                <div class="col-md-10">
                  <select class="form-select" v-model="datoReferenciaDet.tipo" required>
                    <option value="Presuntivo">Presuntivo</option>
                    <option value="Definitivo">Definitivo</option>
                  </select>
                </div>

              </div>
            </div>
          </form>
          <div class="modal-footer">
            <button
              v-if="btnCrear"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarReferenciaDet"
              title="Guardar"
            >
              <span class="material-symbols-outlined align-middle">save</span> Guardar
            </button>
            <button
              v-if="btnEditar"
              type="button"
              class="btn btn-success px-4"
              @click.prevent="guardarEditReferenciaDet"
              title="Actualizar"
            >
              <span class="material-symbols-outlined align-middle">update</span> Actualizar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from '@/components/DataTable.vue';
import { validarForm } from '@/modules/validacionesForms.js';
import dateFormat from '@/modules/dateFormat.js';
import api from '@/services/api';
import { openModal, closeModal } from '@/modules/modalHelper.js';
import * as $ from 'jquery';
import swal from 'sweetalert';
window['$'] = $;
window['jQuery'] = $;

export default {
  components: { DataTable },

  props: {
    p_idAtencion:     { type: Number, required: true },
    p_numeroAtencion: { type: String, required: true },
    p_idReferencia:   { type: Number, required: true },
    p_estadoAtencion: { type: String, required: true },
  },

  data() {
    return {
      referenciadets:      [],
      datoReferenciaDet:   {},
      titulo:              '',
      btnCrear:            false,
      btnEditar:           false,
      modalWindow:         true,
      diagnosticos:        [],
      filteredDiagnosticos:[],
      searchTextDiag:      '',
    };
  },

  computed: {
    estadoPermitido() {
      return ['PENDIENTE', 'PROCESO'].includes(this.p_estadoAtencion);
    },
  },

  mounted() {
    this.getData();
    this.fetchDiagnosticos();
  },

  methods: {
    getFormattedDate(date) {
      return dateFormat.getFormattedDate(date);
    },

    //  Carga
    async getData() {
      const response = await api.get('/vwreferenciadets');
      this.referenciadets = response.data.reverse();
    },

    //  Validación
    validarForm() {
      return validarForm(this.datoReferenciaDet, ['tipo'], ['Tipo']);
    },

    //  CRUD
async guardarReferenciaDet() {
  if (this.validarForm() === 1) {
    try {
      this.datoReferenciaDet.idReferencia = this.p_idReferencia;
      await api.post('/referenciadets', this.datoReferenciaDet);
      closeModal('ventanaModal');
      swal('Correcto!', 'Diagnóstico registrado exitosamente!', 'success');
      this.getData();
    } catch { swal('Error!', 'Inténtelo de nuevo!', 'error'); }
  }
},

async guardarEditReferenciaDet() {
  if (this.validarForm() === 1) {
    try {
      await api.post('/referenciadets', this.datoReferenciaDet);
      closeModal('ventanaModal');
      swal('Correcto!', 'Diagnóstico actualizado exitosamente!', 'success');
      this.getData();
    } catch { swal('Error!', 'Inténtelo de nuevo!', 'error'); }
  }
},

    async deleteReferenciaDet(idReferenciaDet) {
      try {
        await api.delete('/referenciadets/' + idReferenciaDet);
        this.getData();
      } catch {
        swal('Error!', 'No se pudo eliminar.', 'error');
      }
    },

    //  Modal

abrirModalCrear() {
  this.datoReferenciaDet = {};
  this.titulo    = 'Registrar Diagnóstico';
  this.btnCrear  = true;
  this.btnEditar = false;
  this.searchTextDiag = '';
  openModal('ventanaModal');
},

abrirModalEditar(idReferenciaDet) {
  this.modalWindow = true;
  if (idReferenciaDet) {
    api.get('/vwreferenciadets/' + idReferenciaDet).then(resp => {
      this.datoReferenciaDet = resp.data;
      this.searchTextDiag = `${resp.data.diagnosticoCodigo} - ${resp.data.diagnosticoNombre}`;
    });
  }
  this.titulo    = 'Editar Diagnóstico';
  this.btnCrear  = false;
  this.btnEditar = true;
  openModal('ventanaModal');
},

    //  Búsqueda diagnóstico
    filterDiagnosticos() {
      this.filteredDiagnosticos = this.diagnosticos.filter(d =>
        d.nombre.toLowerCase().includes(this.searchTextDiag.toLowerCase())
      );
    },

    selectDiagnostico(diagnostico) {
      this.datoReferenciaDet.idDiagnostico = diagnostico.idDiagnostico;
      this.searchTextDiag = `${diagnostico.codigo} - ${diagnostico.nombre}`;
    },

    toggleDropdown() {
      this.$refs.dropdownButton?.click();
    },

    //  Catálogos
    fetchDiagnosticos() {
      api.get('/vwdiagnosticos')
        .then(r => {
          this.diagnosticos         = r.data;
          this.filteredDiagnosticos = r.data;
        })
        .catch(e => console.error('Error fetchDiagnosticos:', e));
    },
  },
};
</script>

<style src="@/assets/css/listaFiltrada02.css" scoped></style>